/* eslint-disable consistent-return */
/* eslint-disable arrow-body-style */
/* eslint-disable object-curly-newline */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import styled, { withTheme, css } from 'styled-components/macro';
import { SubWebPeople } from '@uaveiro/ui';
import { useParams } from 'react-router-dom';
import {
  getDepartmentPeople
} from '../../services/requests';


const SubWebPeopleTemplate = ({ data, tabs, structure, ...props }) => {
  const { lang } = props
  const {
    subweb
  } = useParams()
  const [_, setShouldUpdateData] = useState(true);
  const [state, setState] = useState({
    isLoading: true,
    isTabsLoading: true,
    hasError: false,
    data: [],
    selected: 0,
    tabs: [],
    popcorn: true,
  });

  const onFetchData = async (department = 'stic', type = '') => {
    try {
      const requestType = getDepartmentPeople;

      const res = await requestType({
        department,
        type,
        lang
      });
      
      return res;
    } catch (error) {
      setState(prevState => ({
        ...prevState,
        isLoading: false,
        isTabsLoading: false,
        hasError: true
      }));
    }
  };

  const onFetchTabs = async (departmentId, type) => {
    const result = await onFetchData(departmentId);

    setState(prevState => {
      return {
        ...prevState,
        tabs: result.data.tabs,
        selected: Number(result.selected),
        isTabsLoading: false
      };
    }); 
  };

  const onFetchContent = async (department, type) => {
    setShouldUpdateData(true);
    const result = await onFetchData(department, type);

    setState(prevState => ({
      ...prevState,
      data: result.data.data,
      tabs: result.data.tabs,
      selected: Number(result.data.selected),
      isLoading: false,
    }));
  };

  const onChangeTab = value => {

    setState(prevState => {
      return {
        ...prevState,
        isLoading: true
      };
    });

    onFetchContent(subweb, value);
  };

  useEffect(() => {
    if (structure === false) {
      onFetchTabs(subweb, '');
      onFetchContent(subweb, '');
    }

  }, [structure]);

  const peopleProps = {
    ...state,
    data,
    tabs,
    lang,
    structure,
    onChangeTab,
    ...props,
  };

  if (!structure) {
    peopleProps.data = state.data;
    peopleProps.tabs = state.tabs;
  }

  return (
    <Wrapper structure={structure}>
      <SubWebPeople {...peopleProps} popcorn={state.popcorn} isEditor />
    </Wrapper>
  )
}

const Wrapper = styled.div(props => css`
  border-bottom: 1px solid ${props.theme.colors.borderLighter};

  ${props.structure ? `
    section > div:nth-child(2) {
      margin-bottom: unset;
      border-bottom: unset;
    }
    ` : `
    `}
`)

SubWebPeopleTemplate.propTypes = {
};

SubWebPeopleTemplate.defaultProps = {
}

export default withTheme(SubWebPeopleTemplate);

